import { render, staticRenderFns } from "./examine-status.vue?vue&type=template&id=a918742e"
import script from "./examine-status.vue?vue&type=script&lang=ts"
export * from "./examine-status.vue?vue&type=script&lang=ts"
import style0 from "./examine-status.vue?vue&type=style&index=0&id=a918742e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports